"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const BaseBuilder_1 = __importDefault(require("./BaseBuilder"));
const SectionGroupBuilder_1 = __importDefault(require("./SectionGroupBuilder"));
const locale_1 = require("../../locale");
const localization_1 = require("../../../types/localization/localization");
class QuestionnaireBuilder extends BaseBuilder_1.default {
    seedProviders;
    questionnaire;
    constructor(seedProviders) {
        super();
        this.seedProviders = seedProviders;
        this.questionnaire = [];
    }
    with(nodeBuilder) {
        if (nodeBuilder instanceof SectionGroupBuilder_1.default) {
            return this.withSectionGroups(nodeBuilder);
        }
        return this.withSectionGroups(new SectionGroupBuilder_1.default(this.seedProviders).with(nodeBuilder));
    }
    withSectionGroups(sectionGroupBuilders) {
        const builders = sectionGroupBuilders ? lodash_1.default.castArray(sectionGroupBuilders) : [];
        if (builders.length === 0) {
            builders.push(new SectionGroupBuilder_1.default(this.seedProviders));
        }
        const sectionGroups = builders.map((builder) => builder.build());
        this.questionnaire.push(...sectionGroups);
        return this.clone();
    }
    withSteps(sectionBuilders) {
        return this.withSections(sectionBuilders);
    }
    withSections(sectionBuilders) {
        this.questionnaire.push(this.childBuilder().withSections(sectionBuilders).build());
        return this.clone();
    }
    withSubsections(subsectionBuilders) {
        this.questionnaire.push(this.childBuilder().withSubsections(subsectionBuilders).build());
        return this.clone();
    }
    withFieldGroups(fieldGroupBuilders) {
        this.questionnaire.push(this.childBuilder().withFieldGroups(fieldGroupBuilders).build());
        return this.clone();
    }
    withFields(fieldBuilders) {
        this.questionnaire.push(this.childBuilder().withFields(fieldBuilders).build());
        return this.clone();
    }
    build() {
        return lodash_1.default.cloneDeep(this.questionnaire);
    }
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    localize(language = localization_1.Language.en) {
        return {
            build: () => (0, locale_1.localizeQuestionnaire)(lodash_1.default.cloneDeep(this.questionnaire), language),
        };
    }
    childBuilder() {
        return new SectionGroupBuilder_1.default(this.seedProviders);
    }
}
exports.default = QuestionnaireBuilder;
